// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","431":"10fc647c","437":"fa655878","455":"4db70e93","977":"29f78a79"}[chunkId] + ".chunk.js";
};